class CmsBlockV2Model {
  constructor({
    block_id,
    name,
    identifier,
    enabled,
    content_type,
    file,
    block_content,
    params,
    block_content_css: css,
    block_content_js: js,
    component_name,
    collection_page_id,
    resolved_link_url
  }) {
    this.id = block_id
    this.name = name
    this.identifier = identifier
    this.isEnabled = !!enabled
    this.contentType = content_type
    this.file = file
    this.collectionPageId = collection_page_id ?? null
    this.resolvedLinkUrl = resolved_link_url ?? null
    this.blockContent = CmsBlockV2Model.resolveBlockContent(
      block_content,
      collection_page_id,
      resolved_link_url
    )
    this.params = params
    this.css = css
    this.js = js
    this.componentName = component_name
  }

  get isComponent() {
    return this.contentType === 'component'
  }

  static parseBlockContent(raw) {
    if (!raw) return {}
    try {
      return JSON.parse(raw)
    } catch {
      return {}
    }
  }

  static resolveBlockContent(raw, collectionPageId, resolvedLinkUrl) {
    const content = CmsBlockV2Model.parseBlockContent(raw)
    const isCollectionLink =
      collectionPageId != null || content.link_type === 'collection'

    if (!isCollectionLink || resolvedLinkUrl === undefined) return content

    return {
      ...content,
      link_url: resolvedLinkUrl
    }
  }
}

export default CmsBlockV2Model
